/* eslint-disable eqeqeq */
import React, { FC, useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { withProcedureWraper } from '../..';
import { Routes } from '../../../../AppRoutes';
import { Box } from '../../../../components/box';
import { Icon } from '../../../../components/icon';
import { InputDateTime, InputNumber, InputText, InputTextArea } from '../../../../components/input';
import { CreateNotification } from '../../../../components/notifier';
import { Button } from '../../../../modules/button';
import { InputWraper, useForm } from '../../../../modules/form';
import { getDay, getLocalDate, getDiffDay, setUtcTime } from '../../../../helper/dateTimeHelper';
import { useSelector } from 'react-redux';
import { UserSelect } from '../../../../components/input/select/UserSelect';
import { MailService } from '../../../../services/mail/mail.service';
import { getEnv } from '../../../../AppConfigs';
import { mailRegexs } from '../../../../constants/mailTemplateConstants';
import { courseStatus } from '../../../../constants/statusConstants';
import { TrainingService } from '../../../../services/training/training.service';

const siteUrl = getEnv('REACT_APP_APPROVER_TRANING_PLAN_URL');

export const ProcedureTrainingCourseCreatePage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const employees = useSelector((state: any) => state.employee.employees);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const user = useSelector((state: any) => state.user);
  const currentUserName = user?.current?.username;
  const { plancode, id } = useRouteMatch().params as any;
  const today = new Date();
  const [reviewer, setReviewer] = useState('');
  const [reviewerOptions, setReviewerOptions] = useState([]);
  const [userDepartment, setUserDepartment] = useState(null as any);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [minDate, setMinDate] = useState(today);

  const { getInputProps, handleSubmit, isSubmitting, setValues } = useForm({
    structure: [
      {
        name: 'title',
        label: 'Tên khóa học',
      },
      {
        name: 'teacher',
        label: 'Giáo viên phụ trách',
      },
      {
        name: 'numberoftrainee',
        label: 'Số lượng học viên',
      },
      {
        name: 'location',
        label: 'Địa điểm',
      },
      {
        name: 'reviewer',
        label: 'Người đánh giá',
      },
      {
        name: 'from',
        label: 'Ngày bắt đầu',
      },
      {
        name: 'to',
        label: 'Ngày kết thúc'
      },
      {
        name: 'content',
        label: 'Mô tả'
      },
      {
        name: 'note',
        label: 'Ghi chú'
      }
    ],
    onSubmit: async (payload) => {
      const reviewerTmp = employees.find((f: any) => f.eMail === reviewer);
      const trainingCourse: any = {
        fields: {
          Title: payload.title,
          eStartDate: setUtcTime(getDay(startDate)),
          eEndDate: setUtcTime(getDay(endDate)),
          eReviewedBy: reviewerTmp ? `${reviewerTmp.eMail}|${reviewerTmp.Title}` : null,
          eContent: payload.content,
          eNotes: payload.note,
          eTeacher: payload.teacher,
          eLocation: payload.location,
          eNoOfTrainee: payload.numberoftrainee,
          ePlanCode: plancode,
          eStatus: courseStatus.waitingreview,
        }
      };
      addTrainingCourse(trainingCourse);
    }
  })

  const sendMail = async () => {
    const approverTmp = employees.find((f: any) => f.eMail.toLowerCase() === reviewer.toLowerCase());
    const name = approverTmp.Title;
    const tomail = approverTmp.eMail;
    const template = mailtemplates.find((m: any) => m.eMailType === 'TCR');
    const content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.siteUrl, siteUrl);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, 'html', tomail);
    await MailService.sendMail(message);
  }

  const addTrainingCourse = (trainingCourse: any) => {
    if (id != 0) {
      TrainingService.updateTrainingCourse(id, trainingCourse.fields).then(res => {
        CreateNotification({ title: 'Thành công', body: `Chỉnh sửa lớp học thành công.`, icon: '/icons/success.png' });
        history.goBack();
      }, error => {
        CreateNotification({ title: 'Thất bại', body: `Chỉnh sửa lớp học thất bại.`, icon: '/icons/error.png' });
        console.log(error);
      });
    } else {
      TrainingService.addTrainingCourse(trainingCourse).then(res => {
        CreateNotification({ title: 'Thành công', body: `Tạo lớp học thành công.`, icon: '/icons/success.png' });
        sendMail();
        history.goBack();
      }, error => {
        CreateNotification({ title: 'Thất bại', body: `Tạo lớp học thất bại.`, icon: '/icons/error.png' });
        console.log(error);
      });
    }
  }

  const onReviewerChange = (selectedOptions: any) => {
    setReviewer(selectedOptions ? selectedOptions.value : '');
  }

  const onStartDateChange = (date: any) => {
    const newDate = new Date(date);
    setStartDate(newDate);
    const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(endDate)));
    if (days < 0) {
      setEndDate(newDate);
    }
    setTimeout(() => setMinDate(newDate), 0);
  }

  const onEndDateChange = (date: any) => {
    setEndDate(new Date(date));
  }

  const checkUserDepartment = () => {
    const userDepartment = employees.find((o: any) => o.eMail.toLowerCase() === currentUserName.toLowerCase());
    setUserDepartment(userDepartment);
  }

  const getApproverOptions = () => {
    // const reviewers = employees.filter((f: any) => approverTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartment === userDepartment.eDepartment).map((o: any) => ({ label: o.Title, value: o.eMail, default: o.eDefault || false }));
    const reviewers = employees.filter((f: any) => f.eDepartment === userDepartment.eDepartment).map((o: any) => ({ label: o.Title, value: o.eMail, default: o.eDefault || false }));

    setReviewerOptions(reviewers);
    if (reviewers.length > 0) {
      const defaultApprover = reviewers.find((a: any) => a.default);
      setReviewer((defaultApprover && defaultApprover.value) || reviewers[0].value);
    }
  }


  useEffect(() => {
    if (employees && employees.length > 0) {
      checkUserDepartment();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employees])

  useEffect(() => {
    if (userDepartment) {
      getApproverOptions();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDepartment])


  useEffect(() => {
    if (id != 0) {
      TrainingService.getTrainingCourseById(id)
        .then(res => {
          const { eStartDate, eEndDate, eContent, eTeacher, Title, eLocation, eNoOfTrainee, eNotes } = res.fields;
          const startDate = new Date(eStartDate);
          const endDate = new Date(eEndDate);
          setValues({ content: eContent, teacher: eTeacher, title: Title, location: eLocation, numberoftrainee: eNoOfTrainee, note: eNotes });
          setStartDate(startDate);
          setEndDate(endDate);
        })
        .catch(error => console.log(error));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return (
    <div className="TrainingCourseCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.goBack()}>
              <Icon.ArrowLeft />
            </div>
               Quay lại
            </div>
        </div>

        <Box title="Thông tin">
          <form onSubmit={handleSubmit}>
            <InputWraper inputProps={getInputProps('title')} renderInput={s => <InputText
              {...s}
            />} />
            <InputWraper inputProps={getInputProps('from')} renderInput={(s) => <>
              <InputDateTime {...s} value={startDate} onChange={onStartDateChange} />
            </>} />
            <InputWraper inputProps={getInputProps('to')} renderInput={(s) => <>
              <InputDateTime {...s} value={endDate} onChange={onEndDateChange} minDate={minDate} />
            </>} />
            <InputWraper inputProps={getInputProps('location')} renderInput={s => <InputText
              {...s}
            />} />
            <InputWraper inputProps={getInputProps('teacher')} renderInput={s => <InputText
              {...s}
            />} />
            <InputWraper inputProps={getInputProps('numberoftrainee')} renderInput={s => <InputNumber
              {...s}
            />} />
            <InputWraper inputProps={getInputProps('content')} component={InputTextArea} />
            {/* <div className="d-flex mb-3">
              <div className="mr-3">
                <InputCheckbox
                  label="Yêu cầu phê duyệt"
                  name="reviewType"
                  value={!isNeedReview}
                  onTouched={() => false}
                  onChange={e => { setNeedReview(false) }}
                />
              </div>
              <div>
                <InputCheckbox
                  label="Yêu cầu đánh giá"
                  name="reviewType"
                  value={isNeedReview}
                  onTouched={() => false}
                  onChange={e => { setNeedReview(true) }}
                />
              </div>
            </div> */}
            <InputWraper inputProps={getInputProps('reviewer')} renderInput={(s) => <UserSelect {...s} placeholder="Chọn người đánh giá" options={reviewerOptions} value={reviewer} onChange={onReviewerChange} />} />
            <InputWraper inputProps={getInputProps('note')} component={InputTextArea} />

            <Button type="submit" label="Tạo" isLoading={isSubmitting} />
            <Button type="button" label="Huỷ" buttonType="grey-outline" className="ml10" onClick={() => history.push(Routes.procedureTrainingPlan.path)} />
          </form>
        </Box>
      </div>
    </div>
  )
})